import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

export default function UserDashboard() {
  const nav = useNavigate();

  const [showMenu, setShowMenu] = useState(false);
  const [loading, setLoading] = useState(true);

  const [notifCount, setNotifCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [upcomingExams, setUpcomingExams] = useState([]);

  /* 🔹 NEW STATES */
  const [userName, setUserName] = useState("");
  const [userClass, setUserClass] = useState("");

  /* ================= LOGOUT ================= */
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    nav("/login");
  };

  /* ================= USER PROFILE ================= */

  const loadUserProfile = async () => {
    try {

      const res = await api.get("/user/me");

      setUserName(res.data.name || "");
      setUserClass(res.data.clazz || "");

    } catch (e) {

      console.error("User profile load failed", e);

    }
  };


  /* ================= LOAD DATA ================= */
  const loadDashboardData = async () => {
    try {
      setLoading(true);
      const [notifRes, examRes] = await Promise.all([
        api.get("/student/notifications"),
        api.get("/student/upcoming-exams"),
      ]);
      setNotifications(notifRes.data || []);
      setUpcomingExams(examRes.data || []);
    } catch (e) {
      console.error(e);
      setNotifications([]);
      setUpcomingExams([]);
    } finally {
      setLoading(false);
    }
  };

  /* ================= LOAD UNREAD COUNT ================= */
  const loadUnreadCount = async () => {
    try {
      const res = await api.get("/student/notifications/unread-count");
      setNotifCount(res.data.count || 0);
    } catch {
      setNotifCount(0);
    }
  };

  useEffect(() => {
    loadUnreadCount();
    loadDashboardData();
    loadUserProfile();
  }, []);

  /* ================= HANDLE BELL CLICK ================= */
  const openNotifications = async () => {
    try {
      if (notifications[0]?.id) {
        await api.post(`/student/notifications/${notifications[0].id}/read`);
      }
    } catch {}
    setNotifCount(0);
    nav("/student/notifications");
  };

  const latestNotification = notifications[0];

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        {/* ================= HEADER ================= */}
        <header style={headerStyle}>
          <h2 style={{ margin: 0 }}>EduAt10 |  Name: {userName} | Class: {userClass} 😊</h2>

          <div style={headerRight}>
            <div style={bellWrapper} onClick={openNotifications}>
              🔔
              {notifCount > 0 && <span style={notifBadge}>{notifCount}</span>}
            </div>

            <div onClick={() => setShowMenu(!showMenu)} style={avatarStyle}>
              👤
            </div>

            {showMenu && (
              <div style={menuStyle}>
                <button style={menuBtnStyle} onClick={() => nav("/admin/user/me")}>👤 My Profile</button>
                <button style={menuBtnStyle} onClick={() => nav("/my-subscription")}>🎟️ My Subscription</button>
                <button style={menuBtnStyle} onClick={() => nav("/student/support")}>🆘 Create Support</button>
                <button style={{ ...menuBtnStyle, color: "#dc2626" }} onClick={logout}>🚪 Logout</button>
              </div>
            )}
          </div>
        </header>

        {/* LOGO */}
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <img src="/logo.png" alt="EduAt10" style={logoStyle} />
        </div>

        {/* ================= BODY ================= */}
        <div style={bodyStyle}>
          <h3>🎓 Student Dashboard</h3>
          <p>Welcome! Access study material, practice sets & exams.</p>


          {/* ================= NOTIFICATIONS ================= */}
          <section style={{ marginTop: 30 }}>
            <h3>📢 Notifications</h3>

            {loading ? (
              <p>Loading...</p>
            ) : !latestNotification ? (
              <p>No notifications</p>
            ) : (
              <div style={notifCard}>
                <p>{latestNotification.message}</p>
                <button style={examBtn} onClick={openNotifications}>View All</button>
              </div>
            )}
          </section>

          {/* ================= UPCOMING EXAMS ================= */}
          <section style={{ marginTop: 40 }}>
            <h3>⏰ Scholarship Exam / Mega Scholarship Exams</h3>

            {loading ? (
              <p>Loading...</p>
            ) : upcomingExams.length === 0 ? (
              <p>No exams available.</p>
            ) : (
              <div style={examGrid}>
                {upcomingExams.map((exam) => {
                  const isMega = exam.exam_type === "mega";

                  return (
                    <div key={exam.id} style={examCard}>
                      <span style={badge}>
                        {isMega ? "Mega Scholarship" : "Scholarship"}
                      </span>

                      <h4 style={{ marginTop: 10 }}>{exam.title}</h4>
                      <p>{exam.exam_date}</p>
                      <p>{exam.start_time} – {exam.end_time}</p>
                      <p>₹{exam.entry_fee}</p>

                      {exam.is_attempted ? (
                        <button
                          style={{ ...examBtn, background: "#16a34a" }}
                          onClick={() =>
                            nav(`/student/result/${exam.exam_type}/${exam.id}`)
                          }
                        >
                          📊 View Result
                        </button>
                      ) : exam.is_registered ? (
                        <button
                          style={examBtn}
                          onClick={() =>
                            nav(`/student/mega-scholarship/${exam.id}/attempt`)
                          }
                        >
                          ▶ Start Exam
                        </button>
                      ) : (
                        <>
                          <button
                            style={examBtn}
                            onClick={() =>
                              nav(`/student/mega-scholarship/${exam.id}`)
                            }
                          >
                            💳 Pay exam charge
                          </button>

                          {/* ⚠️ MESSAGE ONLY BEFORE PAYMENT */}
                          <p style={{ fontSize: 13, marginTop: 10 }}>
                            छात्रवृत्ति परीक्षा/मेगा छात्रवृत्ति में भाग लेने से पहले,
                            आपको अपनी प्रोफ़ाइल में अपने बैंक विवरण को अपडेट करना होगा।
                            <br />
                            Before participating in Scholarship Exam / Mega Scholarship,
                            you must update your bank details before paying the exam fee.
                          </p>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </section>

          {/* ================= QUICK ACCESS ================= */}
          <div style={cardGrid}>
            <div style={cardStyle} onClick={() => nav("/student/study")}>📚 Study Content</div>
            <div style={cardStyle} onClick={() => nav("/student/practice-list")}>🧠 Practice Sets</div>
            <div style={cardStyle} onClick={() => nav("/student/results")}>📊 Results</div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */
const pageStyle = { minHeight: "100vh", backgroundImage: "url('/eduat10-bg.png')", backgroundSize: "cover" };
const overlayStyle = { minHeight: "100vh", backgroundColor: "rgba(0,0,0,0.25)" };
const headerStyle = { background: "rgba(255,255,255,0.95)", padding: "14px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", position: "sticky", top: 0, zIndex: 20 };
const headerRight = { display: "flex", alignItems: "center", gap: 16, position: "relative" };
const bellWrapper = { position: "relative", cursor: "pointer", fontSize: 18 };
const avatarStyle = { background: "#02884e", borderRadius: "50%", width: 38, height: 38, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" };
const notifBadge = { position: "absolute", top: -6, right: -8, background: "red", color: "white", borderRadius: "50%", padding: "2px 6px", fontSize: 11 };
const menuStyle = { position: "absolute", right: 0, top: 48, background: "white", borderRadius: 8, boxShadow: "0 4px 12px rgba(0,0,0,0.15)", minWidth: 180 };
const menuBtnStyle = { width: "100%", padding: "10px 15px", border: "none", background: "white", textAlign: "left", cursor: "pointer" };
const bodyStyle = { padding: 40, background: "rgba(255,255,255,0.9)", margin: 20, borderRadius: 16 };
const logoStyle = { width: 120 };
const notifCard = { background: "white", padding: 15, borderRadius: 8, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" };
const examGrid = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20, marginTop: 20 };
const examCard = { background: "white", padding: 20, borderRadius: 12, boxShadow: "0 4px 10px rgba(0,0,0,0.08)" };
const badge = { background: "#f59e0b", color: "white", padding: "4px 10px", borderRadius: 20, fontSize: 12 };
const examBtn = { marginTop: 8, padding: "6px 12px", background: "#02884e", color: "white", border: "none", borderRadius: 6, cursor: "pointer" };
const cardGrid = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 20, marginTop: 40 };
const cardStyle = { background: "white", padding: 25, borderRadius: 12, textAlign: "center", cursor: "pointer", fontWeight: 600, boxShadow: "0 2px 8px rgba(0,0,0,0.08)" };
